import { CustomText } from '@vfit/shared/atoms';
import { trackView } from '@vfit/shared/data-access';
import * as S from '../addonCardOffer.style';
import ButtonCBU from '../../ButtonCBU/buttonCBU';

interface IModalProps {
  popupTitle: string;
  popupBody: string;
  added: boolean;
  ctaAddLabel: string;
  addonId: string;
  ctaRemoveLabel: string;
  handleAddAction: (id: string) => void;
  handleRemoveAction: (id: string) => void;
  handleClosePopup: (text: string) => void;
  closePopupLabel: string;
  isPerformingAction: boolean;
  loadingId: string;
}

export const ModalContent = ({
  popupTitle,
  popupBody,
  added,
  ctaAddLabel,
  addonId,
  ctaRemoveLabel,
  handleAddAction,
  handleRemoveAction,
  closePopupLabel,
  handleClosePopup,
  isPerformingAction,
  loadingId,
}: IModalProps) => {
  trackView({
    event_name: 'view',
    event_label_track: 'addons:detail',
  });
  return (
    <>
      <h1>{popupTitle}</h1>
      <CustomText
        text={popupBody}
        textAlign="left"
        size={18}
        sizeMobile={20}
        lineHeight={24}
        lineHeightMobile={26}
      />
      <S.CtaContainer>
        <ButtonCBU
          onClick={() => (added ? handleRemoveAction(addonId) : handleAddAction(addonId))}
          variant={added ? 'secondary' : 'primary'}
          loading={isPerformingAction && loadingId === addonId}
          disabled={isPerformingAction && loadingId !== addonId}
          key={addonId + (added ? '_remove' : '_add')}
        >
          {added ? ctaRemoveLabel : ctaAddLabel}
        </ButtonCBU>
        <ButtonCBU onClick={() => handleClosePopup(closePopupLabel)} variant={'secondary'}>
          {closePopupLabel}
        </ButtonCBU>
      </S.CtaContainer>
    </>
  );
};

